// removed by extract-text-webpack-plugin
module.exports = {"BreadBottom":"BurgerIngredient__BreadBottom__HuxZP","BreadTop":"BurgerIngredient__BreadTop__10-cT","Seeds1":"BurgerIngredient__Seeds1__3xHtz","Seeds2":"BurgerIngredient__Seeds2__1cUso","Meat":"BurgerIngredient__Meat__13nAN","Cheese":"BurgerIngredient__Cheese__1FxeY","Salad":"BurgerIngredient__Salad__1iTJE","Bacon":"BurgerIngredient__Bacon__3vrAI","Onion":"BurgerIngredient__Onion__2GMz3","Tomato":"BurgerIngredient__Tomato__1DN79","Pickles":"BurgerIngredient__Pickles__2_xHe","Pickle1":"BurgerIngredient__Pickle1__2I6GH","Pickle2":"BurgerIngredient__Pickle2__jYjBI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/BurgerIngredient/BurgerIngredient.css
// module id = 137
// module chunks = 3